export const SettingsViewPart = {
    info: "info",
    interests: "interests",
    settings: "settings",
    deviceTest: "deviceTest",
    empty: ""
} as const;

export type SettingsViewPart = typeof SettingsViewPart[keyof typeof SettingsViewPart];